import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Reparation from "../pages/reparation/page";
import Accessoires from "../pages/accessoires/page";
import Contact from "../pages/contact/page";
import MentionsLegales from "../pages/mentions-legales/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/reparation",
        element: <Reparation />,
      },
      {
        path: "/accessoires",
        element: <Accessoires />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/mentions-legales",
        element: <MentionsLegales />,
      },
      {
        path: "/politique-de-confidentialite",
        element: <PolitiqueConfidentialite />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;